import { createSlice } from '@reduxjs/toolkit';

import {
    OrderTicketPayload,
    OrderTicketsById
} from '@customTypes/mirAndTracking/MirAndTracking.types';
import { Action } from 'store/index';

export interface InitialState {
    orderTicketsById: OrderTicketsById;
}

const initialState: InitialState = {
    orderTicketsById: {}
};

export const trackOrdersSlice = createSlice({
    name: 'trackOrders',
    initialState,
    reducers: {
        setOrderTicketsById(
            state,
            {
                payload
            }: Action<
                {
                    orderId: string;
                } & OrderTicketPayload
            >
        ) {
            state.orderTicketsById[payload.orderId] = {
                data: payload.data,
                isLoading: payload.isLoading,
                expanded: payload.expanded
            };
        }
    }
});

export const { setOrderTicketsById } = trackOrdersSlice.actions;
